module.exports = __webpack_public_path__ + "static/media/asignaciones.74a414d6.svg";